import React from 'react';
import Helmet from 'react-helmet';
import BodyClassName from 'react-body-classname';
export var NotFound = function NotFound() {
  return React.createElement(BodyClassName, {
    className: "body--error body--no-footer body--render-error"
  }, React.createElement("div", {
    className: "render-error"
  }, React.createElement(Helmet, null, React.createElement("title", null, "ClassPass | Not Found")), React.createElement("div", {
    className: "render-error"
  }, React.createElement("img", {
    className: "render-error__arm",
    src: require('../../../static/img/404-arm.png'),
    alt: "Arm",
    width: "599",
    height: "548"
  }), React.createElement("img", {
    className: "render-error__kettlebell",
    src: require('../../../static/img/404-weight.png'),
    alt: "Weight",
    width: "654",
    height: "464"
  }), React.createElement("section", {
    className: "render-error__content"
  }, React.createElement("h1", null, "404"), React.createElement("p", null, "Whoops!", React.createElement("br", null), "That\u2019s not how we wanted this to go.")))));
};